<template>
  <v-dialog v-model="requestCafDialog" width="730" persistent no-click-animation scrollable overlay-color="grey-500">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat height="46" class="transparent">
          <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold">Solicitar folios para {{ type }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-3">
              <v-btn class="ml-3" @click="$emit('update:requestCafDialog', false), clearInput()" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>
      <v-divider />
      <v-card-text class="py-4">
        <v-row align="center" no-gutters>
          <v-col cols="3" class="pa-0">
            <img :src="require(`@/assets/backgrounds/modal-folios-upload.svg`)" :height="160" />
          </v-col>
          <v-col cols="9" class="pr-0 pl-15 pt-0">
            <div class="mb-3" v-if="$store?.state?.auth?.account?.country === 'CL'">
              <!-- alert -->
              <v-alert class="inf-alert-blue blue-500--text rounded-md mt-4" :min-height="45" :max-height="95" dense text>
                <div class="d-flex pa-0 my-1">
                  <v-icon color="blue-500" size="22">mdi-information-outline</v-icon>
                  <div class="ml-4 text-description">
                    <span class="body-2" style="line-height: 14px;">
                      <template v-if="type === 'timbraje'">
                        Los folios solicitados serán de
                        <span class="font-weight-bold">uso exclusivo para timbraje.</span>
                      </template>
                      <template v-else>
                        <span class="font-weight-bold">Axteroid</span>
                        empleará los folios solicitados para
                        <span class="font-weight-bold">asignar numeración a los documentos.</span>
                      </template>
                    </span>
                  </div>
                </div>
              </v-alert>
              <!-- end alert -->
            </div>
            <v-col cols="12" class="px-0 pt-0">
              <span class="grey-500--text body-1">Tipo de documento</span>
              <v-autocomplete v-model="$v.newCaf.document_type.$model" :error="$v.newCaf.document_type.$error" label="Selecciona el tipo de documento a solicitar" :items="documentTypesList.filter(({country}) => country == $store?.state?.auth?.account?.country)" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" single-line outlined dense hide-details>
                <template v-slot:item="data">
                  <v-list-item-title class="font-weight-regular">{{data.item.name}}</v-list-item-title>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="4" class="px-0 pt-0">
              <span class="grey-500--text body-1">Cantidad de folios</span>
              <v-text-field v-model="$v.newCaf.quantity.$model" :error="$v.newCaf.quantity.$error" outlined required single-line dense maxlength="100" hide-details />
            </v-col>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions class="px-5 py-2">
        <v-spacer/>
        <v-btn outlined @click="$emit('update:requestCafDialog', false), clearInput()">Cancelar</v-btn>
        <v-btn color="blue-500" :loading="loadingCreateCaf"  @click="createNumbering">Cargar folios</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import documentTypesList from '@/collections/documentTypes'

export default {
  mixins: [
    GenericViewMixin
  ],
  props: {
    requestCafDialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    documentTypesList,
    newCaf: {
      document_type: '',
      quantity: null
    },
    loadingCreateCaf: false
    }),
  watch: {
    requestCafDialog: {
      handler (val) {
        this.requestCafDialog = val
        if (!val) this.clearInput()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    clearInput () {
      this.$v.newCaf.$reset()
      this.newCaf = {
        document_type: '',
        quantity: null
      }
    },
    createNumbering () {
      let payload = {}
      this.$v.newCaf.$touch()
      if (this.$v.newCaf.$invalid) {
        return false
      }

      this.loadingCreateCaf = true
      this.newCaf.quantity = Number(this.newCaf.quantity)
      payload = {
        ...this.newCaf,
        user: this.type === 'timbraje',
        test: this.$route.path.startsWith('/test')
      }

      this.$store.dispatch('branches/CREATE', {
        resource: 'numbering/caf/autoload',
        payload: payload
      })
      .then(() => {
        this.$dialog.message.info('Solicitud recibida exitosamente, se procesará a la brevedad')
        this.$emit('update:requestCafDialog', false)
        this.clearInput()
      })
      .catch((error) => {
        this.$dialog.message.error(error.response.data.message)
      })
      .finally(() => {
        this.loadingCreateCaf = false
      })
    }
  },
  validations: {
    newCaf: {
      document_type: {
        required
      },
      quantity: {
        required
      }
    }
  }
}
</script>